import Vue from 'vue'
import VueRouter from 'vue-router'
import Facturas from '../components/facturas/Container'
import Configuracion from '../components/configuracion/Container'
import Usuarios from '../components/usuarios/Container'
import Login from '../components/login/LoginForm'
import store from '../store'

Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      name: 'home',
      meta:{
          title: 'Facturas',
          requiresAuth: true,
          requiresAdmin: false
      },
      component: Facturas
    },
    {
      path: '/configuracion',
      name: 'configuracion',
      meta:{
          title: 'Configuración',
          requiresAuth: true,
          requiresAdmin: false
      },
      component: Configuracion
    },
    {
      path: '/usuarios',
      name: 'usuarios',
      meta:{
          title: 'Usuarios',
          requiresAuth: true,
          requiresAdmin: true
      },
      component: Usuarios
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '*',
      component: {
          template: '<div>404 Página no encontrada</div>'
      }
    }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // console.log(to.matched[0].path);
  if(to.matched[0].path === '*'){ // La ruta no existe
    if (!store.state.login.isAuth) { // No está autenticado
      next({
        name: 'login'
      });
    }else{
      next({
        name: 'home'
      });
    }
  }else{ // La ruta eciste
    if (to.matched.some(record => record.meta.requiresAuth)) {
      // Esta ruta requiere autenticación, verificamos si está logueado
      // si no, lo redirigimos a la página de login.
      if (!store.state.login.isAuth) {
        next({
          name: 'login'
        });
      } else {
        if(to.meta.requiresAdmin !== null){ // Verificamos si la ruta tiene atributo meta
          if(!to.meta.requiresAdmin || to.meta.requiresAdmin && store.state.login.authUser.isAdmin){// Verificamos si a la ruta que está intentando navegar el usuario tiene permisos de acceso
            next(); // Este next deja pasar al usuario a la ruta que estaba solicitando
          }else{ // si no tiene permisos para acceder, lo redirigimos a la home
            next({
              name: 'home'
            });
          }
        }else{
          next(); // Este next deja pasar al usuario a la ruta que estaba solicitando
        }
      }
    } else {
      //console.log(to.name+' === login && '+store.state.login.isAuth);
      if(to.name === 'login' && store.state.login.isAuth){
        next({
          name: 'home'
        });
      }else{
        next(); // make sure to always call next()!
      }
    }
  }
});

export default router
